import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DonationCardService } from '../../../services/donation-card.service';
import { DonorContactDetails, Address } from '../../../models/DonationCardModels';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-donation-contact-tab',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './donation-contact-tab.component.html',
  styleUrl: './donation-contact-tab.component.scss'
})
export class DonationContactTabComponent implements OnInit {
  @Input() donationId!: number;
  @Input() isReadOnlyMode: boolean = false;

  contact?: DonorContactDetails;
  primaryAddress: Address = { address1: '', address2: '', city: '', state: '', zipcode: '', isPrimaryString: 'No', isPrimary: false };
  businessAddress: Address = { address1: '', address2: '', city: '', state: '', zipcode: '', isPrimaryString: 'No', isPrimary: false };
  phoneNumber: string = '';
  cellPhone: string = '';
  emailAddress: string = '';
  workEmailAddress: string = '';

  constructor(private service: DonationCardService, private messageService: MessageService) { }

  ngOnInit(): void {
    this.service.getContactInfo(this.donationId).subscribe(data => {
      this.contact = data;

      // Find primary address
      const home = data.addresses?.find(addr => addr.addressType?.toLowerCase() === 'home');
      if (home) {
        this.primaryAddress = {
          address1: home.address1,
          address2: home.address2,
          city: home.city,
          state: home.state,
          zipcode: home.zipcode,
          isPrimary: home.isPrimaryString === 'Yes' ? true : false
        };
      }

      // If needed: Extract business address by type
      const business = data.addresses?.find(addr => addr.addressType?.toLowerCase() === 'business');
      if (business) {
        this.businessAddress = {
          address1: business.address1,
          address2: business.address2,
          city: business.city,
          state: business.state,
          zipcode: business.zipcode,
          isPrimary: business.isPrimaryString === 'Yes' ? true : false
        };
      }

      // Set phone number: use HomePhone type
      const homePhone = data.phones?.find(p => p.phoneType?.toLowerCase() === 'homephone');
      const cellPhone = data.phones?.find(p => p.phoneType?.toLowerCase() === 'cellphone');
      this.phoneNumber = homePhone?.donorPhoneNumber || '';
      this.cellPhone = cellPhone?.donorPhoneNumber || '';

      // Set email if available
      this.emailAddress = data.emails?.find(email => email.emailType?.toLowerCase() === 'primary')?.email || '';
      this.workEmailAddress = data.emails?.find(email => email.emailType?.toLowerCase() === 'business')?.email || '';
    });
  }
}
